import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowUpDown = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 4.25a.75.75 0 0 1 .75.75v12.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V5A.75.75 0 0 1 8 4.25M16 4.25a.75.75 0 0 1 .53.22l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72V19a.75.75 0 0 1-1.5 0V6.81l-2.72 2.72a.75.75 0 1 1-1.06-1.06l4-4a.75.75 0 0 1 .53-.22"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgArrowUpDown;
